const defaultState: any[] = []

export const SET_RESULT_PANNEL_DROPLETS = 'SET_RESULT_PANNEL_DROPLETS';

export const resultPannelDropletsReducer = (state = defaultState, action: any) => {
    const { type } = action;
    if (type === SET_RESULT_PANNEL_DROPLETS) return action.data
    return state;
}